const validOrigin = value => {
  if (!value) return null;
  try {
    const url = new URL(value);
    return /^https?:$/.test(url.protocol) ? url.origin : null;
  } catch { return null; }
};

export const resolveBackendUrl = (configuredUrl, browserOrigin) => {
  const configuredOrigin = validOrigin(configuredUrl);
  const runtimeOrigin = validOrigin(browserOrigin);
  const runtimeHost = runtimeOrigin ? new URL(runtimeOrigin).hostname : "";
  if (configuredOrigin && ["127.0.0.1", "localhost"].includes(runtimeHost)) return configuredOrigin;
  if (runtimeOrigin && configuredOrigin && runtimeOrigin !== configuredOrigin) return runtimeOrigin;
  return configuredOrigin || runtimeOrigin;
};